import Vue from 'vue'
import Toasted from 'vue-toasted'
import {mapGetters, mapActions} from 'vuex'

// const eventHub = new Vue();
import {eventHub} from './main'

export default {
    install (Vue, options) {
        Vue.mixin({
            data: function () {
                return {
                    eventHub: eventHub
                }
            },
            computed: {
                ...mapGetters([
                    'getUserAccessType',
                    'getNotifications',
                ]),
            },
            methods: {
                ...mapActions([
                    'fetchNotifications',
                    'addFloatingNotification',
                    'removeAllFloatingNotifications',
                    'displayRichPrompt',
                    'hideRichPrompt',
                    'updateClonedItem',
                ]),
                downloadNotifications: function () {
                    let vm = this
                    this.fetchNotifications().then(output => {

                        if(!output){
                            return false
                        }

                        // if is the first notification pull and there are unread notifications

                        // Have notifications AND stored notifications == 0
                        let storedNotifications = JSON.parse(JSON.stringify(output.previousStoredNotifications))
                        if(output && output.allNotifications.length > 0 && storedNotifications.length == 0){
                            let unreadNotifications = output.allNotifications.filter(notification => {
                                return !notification.markedAsRead
                            })

                            if(unreadNotifications.length > 0){
                                // vm.$awn.info('You have '+unreadNotifications.length+' unread notifications')
                                this.spawnNotification({
                                    title: 'You have '+unreadNotifications.length+' unread notifications'
                                }, 'info')

                            }
                        } else if(output && output.newNotifications.length > 0 && storedNotifications.length > 0){
                            for (let newNotification of output.newNotifications) {
                                // vm.$awn.info(newNotification.title)
                                let options = {}
                                if(newNotification.type == 3){
                                    options.link = '/reservations'
                                }
                                this.spawnNotification(newNotification, 'info', options)
                            }
                        }
                    });
                },
                spawnNotification: function (notification, type, options) {
                    // *******************************************
                    // notification.title
                    // notification.message
                    // notification.date
                    // *******************************************
                    // type: tip | info | success | warning | alert
                    // *******************************************
                    // options.link
                    // *******************************************



                    let useSystemNotification = false
                    if(useSystemNotification){
                        if('Notification' in window && Notification.permission == 'granted'){
                            this.spawnNotificationBrowser(notification, type, options)
                        } else {
                            this.spawnNotificationCustom(notification, type, options)
                        }
                    } else {
                        this.spawnNotificationCustom(notification, type, options)
                    }

                },
                spawnNotificationBrowser: function (notification, type, options) {
                    options = (typeof options == 'object')? options : {}
                    let icon = '/static/favicon/ms-icon-310x310.png'
                    var spawnedNotification = new Notification(
                        notification.title,
                        {
                            icon: icon,
                            body: notification.message
                            // tag:'asd'
                        }
                    );
                },
                spawnNotificationCustom: function (notification, type, options) {
                    console.log('notificationSpawn', notification);

                    // add link to notification
                    // if(options.link){
                    //     notification.title = '<a href="options.link">' + notification.title + '</a>'
                    //     notification.message = '<a href="options.link">' + notification.message + '</a>'
                    // }
                    // testing new floating notifications
                    this.addFloatingNotification(notification)

                    /*
                    let typesWithBodyBelowDate = [4]

                    let notificationBody = ''

                    // close notification icon
                    notificationBody += '<i class="closeIcon dark fs-large fas fa-times"></i>'

                    // notification title
                    notificationBody += notification.title? '<div class="bold">'+notification.title+'</div>': ''

                    // Body
                    if(!typesWithBodyBelowDate.includes(notification.type)){
                        notificationBody += notification.message? '<div class="fs-small">'+notification.message+'</div>' : ''
                    }

                    // Date
                    notificationBody += notification.date? '<div class="fs-smaller dark bold">'+this.notificationDateTime(notification)+'</div>' : ''

                    // Body
                    if(typesWithBodyBelowDate.includes(notification.type)){
                        notificationBody += notification.message? '<div class="fs-small mt-2">'+notification.message+'</div>' : ''
                    }

                    // add link to entire notification
                    if(options && options.link){
                        notificationBody = '<a href="'+options.link+'" target="_blank">'+notificationBody+'</a>'
                    }

                    // invoke notification
                    this.$awn[type](notificationBody)
                    */

                },
                clearAllCustomNotifications: function () {
                    this.removeAllFloatingNotifications()
                    if(this.$awn.container){
                        for (let notification of this.$awn.container.children) {
                            notification.click()
                        }
                    }
                    // console.log('clearAllCustomNotifications', this.$awn.container);
                },
                accessPermissionFilter: function(permissionCodeArray) {
                    // receives and array of access codes (example: ["admin","basic"])
                    // and returns bool true if current user corresponds to access code
                    // if undefined defaults to basic user
                    // check store user.js
                    // return true // debug

                    //also allows for group (see the "supervisor" example)
                    return permissionCodeArray.filter(reqAccessCode => {
                        return reqAccessCode == this.getUserAccessType.code || reqAccessCode == this.getUserAccessType.group
                    }).length > 0
                },
                formatPrice: function(price) {
                    // return parseFloat(price).toFixed(2);
                    let rounded = Math.round(price * 100) / 100;
                    return parseFloat(rounded).toFixed(2);

                },
                roundPriceValue: function(price) {
                    return Math.round(price * 100) / 100;
                },
                formatTicketNumber: function(ticketNr) {
                    let targetLength = 5; //ex.: 000123
                    ticketNr = ticketNr + '';

                    return '#'+ (ticketNr.length >= targetLength ? ticketNr : new Array(targetLength - ticketNr.length + 1).join('0') + ticketNr);
                },
                formatDate: function(date) {
                    return moment(date).format('YYYY-MM-DD');
                },
                formatDateDots: function(date) {
                    return moment(date).format('DD.MM.YYYY');
                },
                formatTime: function(date) {
                    return moment(date).format('HH:mm');
                },
                calculateDuration: function (staringTime, endingTime) {
                    // time format: "2018-06-11 15:00:00"
                    var timeStart = moment(staringTime);
                    var timeEnd = moment(endingTime);

                    var duration = timeEnd.diff(timeStart)

                    return moment.utc(duration).format('HH')+'h'+moment.utc(duration).format('mm') + 'm'
                },
                hourToDuration: function(hourString) {
                    // format: 01:00:00
                    let durationArr = hourString.split(":")

                    let hours = durationArr[0]
                    let minutes = durationArr[1]

                    return hours+'h'+minutes+'m'
                },
                nowDate: function() {
                    return moment().format('YYYY-MM-DD');
                },
                nowTime: function() {
                    return moment().format('HH:mm');
                },

                // Creates an URI encoded query string from a JSON array

                parseQueryString: function(params) {
                    let esc = encodeURIComponent;
                    return Object.keys(params).map(k => esc(k) + '=' + esc(params[k])).join('&');
                },

                // Adds leading zeros to numbers smaller than 10 (01, 02 ...) on a list

                leadingZeros: function(list) {
                    let newList = [];

                    list.forEach(number => {
                        newList.push(('0' + number).slice(-2));
                    });

                    return newList;
                },
                getMonthDateRange: function(date) {
                    // Month in moment is 0 based, so 9 is actually october, subtract 1 to compensate

                    let start = moment(date).startOf('month');
                    let end = moment(date).endOf('month');

                    return { start: this.formatDate(start), end: this.formatDate(end) };
                },
                getWeekDateRange: function(date) {
                    let start = moment(date).startOf('isoWeek');
                    let end = moment(date).endOf('isoWeek');

                    return { start: this.formatDate(start), end: this.formatDate(end) };
                },

                showTicketPrice: function(eventGenderPrice){
                    // if(eventGenderPrice.productGenderPriceComponents && eventGenderPrice.productGenderPriceComponents.length > 0){
                    //     let calculateTotal = 0;
                    //
                    //     for(let priceComponent of eventGenderPrice.productGenderPriceComponents){
                    //         if(priceComponent.selectedPrice){
                    //             calculateTotal += priceComponent.selectedPrice.grossprice
                    //         }
                    //     }
                    //
                    //     return calculateTotal
                    //
                    // } else {
                    //     return eventGenderPrice.grossprice
                    // }

                    if(eventGenderPrice.grossprice){
                        return eventGenderPrice.grossprice
                    } else {
                        return null
                    }
                },

                showMandatoryExtras: function(reservation) {
                    if(reservation.event.product.extras.length > 0){
                        var mandatoryExtrasArr = reservation.event.product.extras.filter(extra => {
                            return extra.isMandatory
                        })

                        if(mandatoryExtrasArr.length > 0){
                            var extrasNameArr = []
                            mandatoryExtrasArr.map(extra => {
                                extrasNameArr.push(extra.item.name + ' - ' + extra.item.selectedPrice.name)
                            })

                            this.$dialog.alert('The following '+ ((mandatoryExtrasArr.length > 1)? 'extras are':'extra is') +' mandatory: <br>' + extrasNameArr.join('<br>') , {okText: 'OK'})
                            .then(function () {

                            })
                            .catch(function () {
                            });
                        }

                    } else {
                        return false
                    }
                },

                openByteArrayNewTab: function (byteArray, filename) {
                    if(!filename){
                        filename = 'file'
                    }

                    // IE workaround
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {

                        var byteCharacters = atob(byteArray);
                        var byteNumbers = new Array(byteCharacters.length);
                        for (var i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        var byteArray = new Uint8Array(byteNumbers);
                        var blob = new Blob([byteArray], {type: 'application/pdf'});
                        window.navigator.msSaveOrOpenBlob(blob, filename+'.pdf');
                    } else { // much easier if not IE
                        let pdfWindow = window.open("")
                        pdfWindow.document.write("<iframe width='100%' height='100%' frameBorder='0' src='data:application/pdf;base64, " + encodeURI(byteArray)+"'></iframe>")
                    }
                },

                // Inventory -> Product
                productAcivateUpdateFlag: function (flagName) {
                    if(!this.form.updateFlags){
                        this.$set(this.form, 'updateFlags', {})
                    }
                    this.form.updateFlags[flagName] = true
                    console.log('update flags enabled');
                    this.updateClonedItem(this.form);
                },
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/mixins.js